import { createContext, useContext, useState, type ReactNode } from "react";

type ListSelectionContextType = {
  activeList: { id: number; name: string } | null;
  setActiveList: (id: number, name: string) => void;
  clearActiveList: () => void;
};

const ListSelectionContext = createContext<ListSelectionContextType | undefined>(undefined);

export const ListSelectionProvider = ({ children }: { children: ReactNode }) => {
  const [activeList, setActiveListState] = useState<{ id: number; name: string } | null>(null);

  const setActiveList = (id: number, name: string) => setActiveListState({ id, name });
  const clearActiveList = () => setActiveListState(null);

  return (
    <ListSelectionContext.Provider value={{ activeList, setActiveList, clearActiveList }}>
      {children}
    </ListSelectionContext.Provider>
  );
};

export const useSharedListSelection = () => {
  const context = useContext(ListSelectionContext);
  if (!context) {
    throw new Error("useSharedListSelection must be used within a ListSelectionProvider");
  }
  return context;
};
